import {createReducer} from '@reduxjs/toolkit';
import {getUsersByEmailsSuccess} from 'src/openapi/apis/UserControllerApi';
import {User} from 'src/openapi/models/User';

type State = {
    data: Record<string, User>,
};

const defaultState = {
    data: {},
};

export const usersInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getUsersByEmailsSuccess, (state, action) => {
        state.data = {...state.data,
            ...action.payload.data.reduce((users, currentUser) => {
                return {...users, [currentUser.email]: currentUser};
            }, {}),
        };
    }),
);
